import { render, staticRenderFns } from "./ModalHandleGroup.vue?vue&type=template&id=9c7dd23a"
import script from "./ModalHandleGroup.vue?vue&type=script&lang=js"
export * from "./ModalHandleGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports